/**
 * @module kernel
 * @memberof kernel
 * @package
 * @description Main Kernel entry point
 */
//module name is set to _kernel, so we can later use this as a section name
import Bootstrap from "kernel/bootstrap/Bootstrap";

//require(['kernel/bootstrap/Bootstrap'], function(bootstrap){
	var bootstrap = Bootstrap();
	bootstrap.init(document.body);
	/*
},function(err){
	console.warn(err.requireModules && err.requireModules[0]);
});

requirejs.config({
	catchError:true
});

requirejs.onError = function (err) {
    if (err.requireType === 'timeout' || err.requireType ==='scripterror') {
		console.warn(err);
    } else {
		console.warn(err);
        throw err;

    }
};
	 */